// JavaScript source code
import React from 'react';
import {
    Dialog,
    DialogContent,
    CardContent,
    Typography,
    AccordionSummary,
    AccordionDetails,
    Grid,
    Button,
    Divider
} from '@material-ui/core'
import clsx from 'clsx';
import AssignmentIcon from '@material-ui/icons/Assignment';

import useStyles from '../../../styles/components/survey/stylesSurvey';

const SurveySummaryModal = ({ isOpen, surveySummaryViewModel, closeAction }) => {
    const classes = useStyles()

    return (
        <Dialog
            classes={{ paperWidthFalse: classes.paperWidthFalse }}
            fullWidth={true}
            maxWidth={false}
            open={isOpen} onClose={closeAction}>
            <DialogContent>
                {/* <div className="completedsurvey__root" width="400px"> */}
                <Grid container justify="center">
                    <Grid
                        container
                        justify="center"
                        direction="column"
                        alignItems="center"
                        item xs={12}
                        classes={{ root: classes.rootWrapperTitle }}
                    >
                        <div className={clsx(classes.textDialog, classes.textDialogTitle)}>
                            Survey Summary
                            </div>
                    </Grid>
                </Grid>
                <CardContent>

                    {
                        surveySummaryViewModel != null && surveySummaryViewModel.length > 0 ?
                            surveySummaryViewModel.map((content, index) => (
                                <div key={index}>
                                    <AccordionSummary>
                                        <Grid
                                            container
                                            direction="column"
                                            justify="center"
                                            alignItems="center">
                                            <Typography className="adventurelearn__header">
                                                {content.title}
                                            </Typography>
                                            <Typography className="surveysummary__gradespace">
                                                {content.evaluation}
                                            </Typography>
                                        </Grid>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div dangerouslySetInnerHTML={{ __html: content.description }} />
                                    </AccordionDetails>
                                    <Divider />
                                </div>
                            ))
                            : ''
                    }

                    {
                        surveySummaryViewModel != null ?
                            <Grid container justify="center">
                                <Button
                                    onClick={() => closeAction()}
                                    startIcon={<AssignmentIcon />}
                                    classes={{ root: classes.rootButtonDialog }}
                                >
                                    Surveys
                                        </Button>
                            </Grid>
                            : ''
                    }
                </CardContent>
                {/* </div> */}
            </DialogContent>
        </Dialog >
    );
}

export { SurveySummaryModal as default }